import img1 from "../images/friocid/img1.jpg";
import img2 from "../images/friocid/img2.jpg";
import img3 from "../images/friocid/img3.jpg";
import img4 from "../images/friocid/img4.jpg";
import img5 from "../images/friocid/img5.jpg";
import img6 from "../images/friocid/img6.jpg";

export const imgFrioCid = [
  {
    id: 5101,
    image: img1
  },
  {
    id: 5102,
    image: img2
  },
  {
    id: 5103,
    image: img3
  },
  {
    id: 5104,
    image: img4
  },
  {
    id: 5105,
    image: img5
  },
  {
    id: 5106,
    image: img6
  }  
];